import React from "react";
import Icon, { PhoneOutlined } from '@ant-design/icons';
import { Button, Col, Divider, Input, Row } from "antd";
import AuthDialogWidget from "components/AuthDialogWidget/AuthDialogWidget";
import NormalButton from "components/ButtonWidgets/NormalButton/NormalButton";
import InputPassword from "components/InputWidgets/InputPassword/InputPassword";
import { useState } from "react";
import { withRouter } from "react-router";
import "./InputPage.css";
import { ReactComponent as userIcon } from '../../assets/icons/ic_user.svg';
import { ReactComponent as emailIcon } from '../../assets/icons/ic_envelope.svg';
import { ValidateEmail, isEmpty, isNumber } from "utils/GlobalFunctions";
import ReactCodeInput from "react-code-input";
function InputPage(props) {
  const { userDetail, setUserDetail, isBusy, registrationInfo, step, setStep } = props;
  const { onSubmit } = props;
  const [wrongList, setWrongList] = useState([]);

  const validateFields = () => {
    var errorList = Array();
    if (step == 0) {
      errorList = isEmpty(userDetail, "first_name", errorList);
      errorList = isEmpty(userDetail, "last_name", errorList);
      errorList = isEmpty(userDetail, "email", errorList);
      if (!errorList.includes("email")) {
        if (ValidateEmail(userDetail.email) === false) {
          errorList.push("email");
        }
      }
      errorList = isEmpty(userDetail, "cell_phone", errorList);
      errorList = isEmpty(userDetail, "password", errorList);
      errorList = isEmpty(userDetail, "confirm_password", errorList);
      if (userDetail["password"] !== userDetail["confirm_password"]) {
        errorList = [...errorList, "password"];
        errorList = [...errorList, "confirm_password"];
      }
    } else if (step == 1) {
      if (userDetail.code.length !== 8) {
        errorList.push("code");
      }
    }
    setWrongList([...errorList]);
    return errorList.length == 0;
  };
  const onChangeCode = (value) => {
    if (wrongList.includes("code")) {
      let tmpList = [...wrongList]
      setWrongList(tmpList.filter((x) => x !== "code"))
    }
    setUserDetail({ ...userDetail, code: value })
  };
  const onClickNext = () => {
    if (validateFields() === false) {
      return;
    }
    onSubmit();
  };
  return (
    <div className="main-background-rect" style={{ background: "#ffffff" }}>
      <div style={{ background: "#ffffff", textAlign: 'center', width: '700px', margin: 'auto' }} className="logo-rects">
        <AuthDialogWidget title={registrationInfo?.homepage_title} top={70} registrationInfo={registrationInfo}>
          {step == 0 && <Row gutter={[16, 16]} style={{ marginTop: 30 }}>
            <Col sm={24} md={12}>
              <div className="email-input">
                <Input
                  type="text"
                  prefix={<Icon component={userIcon} className="menu-item-icon" />}
                  suffix={""}
                  placeholder="First Name"
                  value={userDetail.first_name === undefined ? "" : userDetail.first_name}
                  onChange={(e) => {
                    if (wrongList.includes("first_name")) {
                      let tmpList = [...wrongList]
                      setWrongList(tmpList.filter((x) => x !== "first_name"))
                    }
                    setUserDetail({ ...userDetail, first_name: e.target.value })
                  }
                  }
                  style={{
                    border:
                      wrongList.includes("first_name")
                        ? "1px solid var(--redColor)"
                        : "1px solid var(--greyColor)",
                  }}
                />
              </div>
            </Col>
            <Col sm={24} md={12}> <div className="email-input">
              <Input
                type="text"
                prefix={<Icon component={userIcon} className="menu-item-icon" />}
                suffix={""}
                placeholder="Last Name"
                value={userDetail.last_name === undefined ? "" : userDetail.last_name}
                onChange={(e) => {
                  if (wrongList.includes("last_name")) {
                    let tmpList = [...wrongList]
                    setWrongList(tmpList.filter((x) => x !== "last_name"))
                  }
                  setUserDetail({ ...userDetail, last_name: e.target.value })
                }
                }
                style={{
                  border:
                    wrongList.includes("last_name")
                      ? "1px solid var(--redColor)"
                      : "1px solid var(--greyColor)",
                }}
              />
            </div></Col>
            <Col sm={24} md={12}><div className="email-input">
              <Input
                type="text"
                prefix={<Icon component={emailIcon} className="menu-item-icon" />}
                suffix={""}
                placeholder="Email"
                value={userDetail.email === undefined ? "" : userDetail.email}
                onChange={(e) => {
                  if (wrongList.includes("email")) {
                    let tmpList = [...wrongList]
                    setWrongList(tmpList.filter((x) => x !== "email"))
                  }
                  setUserDetail({ ...userDetail, email: e.target.value })
                }
                }
                style={{
                  border:
                    wrongList.includes("email")
                      ? "1px solid var(--redColor)"
                      : "1px solid var(--greyColor)",
                }}
              />
            </div></Col>
            <Col sm={24} md={12}>
              <div className="email-input">
                <Input
                  type="text"
                  prefix={<PhoneOutlined style={{ color: 'white' }} />}
                  placeholder="Cell Phone"
                  value={userDetail.cell_phone === undefined ? "" : userDetail.cell_phone}
                  onChange={(e, w) => {

                    let str = e.target.value;
                    let filStr = str.replace(/[- ]/g, "");
                    let tmpPhone = "";
                    if (filStr == "" || filStr.length == 0) {
                      setUserDetail({ ...userDetail, cell_phone: "" })
                      return;
                    }
                    if (!isNumber(filStr)) {
                      return;
                    }
                    if (filStr.length > 10) {
                      return;
                    }

                    if (wrongList.includes('cell_phone')) {
                      let errors = wrongList.filter(
                        (y) => y != 'cell_phone'
                      );
                      setWrongList([...errors]);
                    }


                    if (filStr.length > 3 && filStr.length < 7) {
                      str = filStr.slice(0, 3) + "-" + filStr.slice(3);
                    }

                    if (filStr.length > 6) {
                      str =
                        filStr.slice(0, 3) +
                        "-" +
                        filStr.slice(3, 6) +
                        "-" +
                        filStr.slice(6);
                    }
                    setUserDetail({ ...userDetail, cell_phone: str })
                  }}
                />
              </div>

            </Col>
            <Col sm={24} md={12}><div className="pass-input">
              <InputPassword
                field={"password"}
                userDetail={userDetail}
                setUserDetail={setUserDetail}
                wrongList={wrongList}
                setWrongList={setWrongList}
                placeholder={"Password"}
              />
            </div></Col>
            <Col sm={24} md={12}><div className="pass-input">
              <InputPassword
                field={"confirm_password"}
                userDetail={userDetail}
                setUserDetail={setUserDetail}
                wrongList={wrongList}
                setWrongList={setWrongList}
                placeholder={"Confirm Password"}
                type={"login"}
              />
            </div></Col>
          </Row>}


          {step == 1 && <>
            <p>Enter the 8 digit verification code sent to the provided email address.</p>
            <ReactCodeInput
              value={userDetail.code}
              isValid={!wrongList.includes("code")}
              fields={8}
              onChange={onChangeCode}
            />
          </>}


          <div style={{ width: 300, margin: 'auto', paddingTop: 40 }}>
            <NormalButton
              style={{ backgroundColor: "#7fb522" }}
              onClick={onClickNext}
              isBusy={isBusy}
            >
              {step == 0 && <>Signup</>}
              {step == 1 && <>Verify Code</>}
            </NormalButton>
          </div>
        </AuthDialogWidget>
      </div>
    </div >
  );
}

export default withRouter(InputPage);
